export function isSignatureVerificationEnabled(ioSecure) {
    return !!(ioSecure === null || ioSecure === void 0 ? void 0 : ioSecure.ioSignatureVerificationEnabled);
}
export var toggleIOSignatureVerificationURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/settings/io_signature_verification");
};
export var generateIOSSecretURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/settings/io_secret/generate");
};
export var getIOSecretURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/settings/io_secret");
};
export var validateIOSignatureURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/io_signature/validate");
};
// Storage keys
var getStorageKeys = function (partnerId) { return ({
    signature: "".concat(partnerId, "-io_signature"),
    timestamp: "".concat(partnerId, "-io_timestamp")
}); };
// Signature params (sessionStorage)
export function storeSignatureParams(partnerId, params) {
    var keys = getStorageKeys(partnerId);
    try {
        if (params.io_signature) {
            sessionStorage.setItem(keys.signature, params.io_signature);
        }
        else {
            sessionStorage.removeItem(keys.signature);
        }
        if (params.io_timestamp) {
            sessionStorage.setItem(keys.timestamp, params.io_timestamp);
        }
        else {
            sessionStorage.removeItem(keys.timestamp);
        }
    }
    catch (_a) {
        /* ignore */
    }
}
export function retrieveSignatureParams(partnerId) {
    var keys = getStorageKeys(partnerId);
    try {
        return {
            io_signature: sessionStorage.getItem(keys.signature),
            io_timestamp: sessionStorage.getItem(keys.timestamp)
        };
    }
    catch (_a) {
        return { io_signature: null, io_timestamp: null };
    }
}
export function clearSignatureParams(partnerId) {
    var keys = getStorageKeys(partnerId);
    try {
        sessionStorage.removeItem(keys.signature);
        sessionStorage.removeItem(keys.timestamp);
    }
    catch (_a) {
        /* ignore */
    }
}
export function prepareSignatureForCallback(partnerId) {
    return retrieveSignatureParams(partnerId);
}
export function extractAndStoreSignatures(partnerId) {
    try {
        var searchParams = new URLSearchParams(window.location.search);
        var params = {
            io_signature: searchParams.get("io_signature") || searchParams.get("signature"),
            io_timestamp: searchParams.get("io_timestamp") || searchParams.get("timestamp")
        };
        var hasAnySignatureParam = !!(params.io_signature || params.io_timestamp);
        if (hasAnySignatureParam)
            storeSignatureParams(partnerId, params);
        return !!(params.io_signature && params.io_timestamp);
    }
    catch (_a) {
        return false;
    }
}
//# sourceMappingURL=data:application/json;base64,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